import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";

export default class AddClientToBuddyList extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "addClientToBuddyList";
    }

    public receive(payload: CometOperatorApplication.AddClientToBuddyListCometMessageOpenApiModel): void {
        ClientUserdataStore.setClientLastActivityTimestamp(payload.client.username);
        ClientUserdataStore.set(payload.client);
        OperatorAccountStore.addClientToBuddyList(payload.client.username);
    }

}